export const cardTheme = {
  baseStyle: {},
  variants: {
    eventListCard: {
      container: {
        backgroundColor: '#ffffff',
        p: [2],
        _hover: {
          borderColor: 'action.light',
          boxShadow: '0 0 0 2px var(--chakra-colors-action-light)',
        },
      },
      body: {
        p: 3,
      },
      footer: {
        p: 2,
        h: '100%',
        alignItems: 'flex-end',
      },
    },
    eventListCardHover: {
      container: {
        backgroundColor: '#ffffff',
        p: [2],
        borderColor: 'action.light',
        boxShadow: '0 0 0 2px var(--chakra-colors-action-light)',
        _hover: {
          borderColor: 'action.light',
          boxShadow: '0 0 0 2px var(--chakra-colors-action-light)',
        },
      },
      body: {
        p: 3,
      },
      footer: {
        p: 2,
        h: '100%',
        alignItems: 'flex-end',
      },
    },
  },
  defaultProps: {},
};
